// components/trust/SkillBadge.jsx
import React from 'react';
import { Award, CheckCircle, Clock, AlertCircle } from 'lucide-react';

const SkillBadge = ({ skill, size = 'medium', showStatus = true, onClick }) => {
  // Determine badge styling based on skill properties
  const getTierColor = (tier) => {
    switch (tier) {
      case 3:
        return 'bg-purple-100 text-purple-700 border-purple-200';
      case 2:
        return 'bg-yellow-100 text-yellow-700 border-yellow-200';
      case 1:
      default:
        return 'bg-green-100 text-green-700 border-green-200';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case 'verified':
        return <CheckCircle className="text-green-600" size={14} />;
      case 'pending':
        return <Clock className="text-yellow-600" size={14} />;
      case 'rejected':
        return <AlertCircle className="text-red-600" size={14} />;
      default:
        return null;
    }
  };

  const sizeClasses = {
    small: 'text-xs px-2 py-1',
    medium: 'text-sm px-3 py-1.5',
    large: 'text-base px-4 py-2'
  };

  const badgeClass = `
    inline-flex items-center rounded-full border font-medium
    ${getTierColor(skill.tier || 1)}
    ${sizeClasses[size]}
    ${onClick ? 'cursor-pointer hover:opacity-80 transition-opacity' : ''}
  `;

  return (
    <div
      className={badgeClass}
      onClick={onClick}
      role={onClick ? 'button' : undefined}
      tabIndex={onClick ? 0 : undefined}
    >
      <Award size={size === 'small' ? 12 : size === 'large' ? 18 : 14} className="mr-1" />
      <span>{skill.name}</span>
      {showStatus && skill.status && (
        <span className="ml-1.5">
          {getStatusIcon(skill.status)}
        </span>
      )}
    </div>
  );
};

export default SkillBadge;